/* eslint-disable no-magic-numbers */
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-mobile-dashboard-comparison',
  templateUrl: './mobile-dashboard-comparison.component.html',
  styleUrls: ['./mobile-dashboard-comparison.component.scss',],
})
export class MobileDashboardComparisonComponent {

  mobile = false;
  dashboard = true;
  faCheck = faCheck;
  faArrowRight = faArrowRight;

  constructor(private _router: Router) { }
  
  elementClick(element: number) {
    if (element === 1) {
      this.mobile = true;
      this.dashboard = false;
    }
    if (element === 2) {
      this.dashboard = true;
      this.mobile = false;
    }
  }
}
